import { ipaCombiners, IpaType } from "../../phonemes/ipa";
import { segmentPhonemes } from "../../phonemes/segmentPhonemes";
import { convertSynthToIpa } from "../../speak/convertSynthToIpa";
import { ipaToSynth } from "../../speak/ipaToSynth";

/**
 * check if the speech synthesizer can speak a phoneme exactly,
 * assumes that multiple consonants are a single phoneme
 * @returns [exact version, approximation | '']
 */
export function checkExact(ipa: IpaType): [IpaType, IpaType] {
  const phonemes = segmentPhonemes(ipa).phonemes;
  const exact = phonemes.length === 1 ? ipa
    : phonemes[0].phoneme + ipaCombiners[0] + phonemes[1].phoneme;

  const meSpeakInput = ipaToSynth(ipa);
  const [backAgain] = convertSynthToIpa(meSpeakInput.speak);
  const actual = backAgain.join('');
  // if exact & actual match, approx should be empty,
  // special case /t̠͡ʃ/ & /d̠͡ʒ/
  const approx = ipa === 't̠͡ʃ' || ipa === 'd̠͡ʒ' ? ''
    : exact === actual ? '' : actual;

  return [exact, approx];
}
